import React from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import NoticeAddForm from "./NoticeAddForm";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));


const NoticeAdd = (props) => {

  const { history  } = props;
  const classes = useStyles();
 
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <NoticeAddForm history={history} />
      </div>
    </div>
  );
};

NoticeAdd.propTypes = {
  history: PropTypes.object
};

export default NoticeAdd;
